// extracted by mini-css-extract-plugin
export var affiImg = "service-card-module--affiImg--n3Lyo";
export var container = "service-card-module--container--5W3wW";
export var content = "service-card-module--content--j9DyC";
export var titleBox = "service-card-module--titleBox--q0hNL";